"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var colorHelpers_1 = __importDefault(require("../../utils/colorHelpers"));
var colors_1 = require("../../constants/colors");
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
exports.Select = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-appearance: none;\n   -moz-appearance: none;\n   -webkit-user-select: none;\n    -moz-user-select: none;\n   appearance: none;\n   background-color: ", ";\n   color: ", ";\n   cursor: pointer;\n   border-color: ", ";\n   border-width: 1px;\n   border-style: ", ";\n   border-radius: 0;\n   margin: 0;\n   padding: ", ";\n   position: relative;\n   font-size: 15px;\n   line-height: 18px;\n   height: ", ";\n   width: ", ";\n   outline: none;\n\n   ::-ms-expand {\n    display: none; /* hide the default arrow in ie10 and ie11 */\n   }\n\n   &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n\n   &:focus {\n    outline: none;\n    border-color: ", ";\n   }\n"], ["\n  -webkit-appearance: none;\n   -moz-appearance: none;\n   -webkit-user-select: none;\n    -moz-user-select: none;\n   appearance: none;\n   background-color: ",
    ";\n   color: ", ";\n   cursor: pointer;\n   border-color: ", ";\n   border-width: 1px;\n   border-style: ", ";\n   border-radius: 0;\n   margin: 0;\n   padding: ",
    ";\n   position: relative;\n   font-size: 15px;\n   line-height: 18px;\n   height: ", ";\n   width: ", ";\n   outline: none;\n\n   ::-ms-expand {\n    display: none; /* hide the default arrow in ie10 and ie11 */\n   }\n\n   &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n\n   &:focus {\n    outline: none;\n    border-color: ", ";\n   }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return backgroundColor ? colorHelpers_1.default(backgroundColor, theme, colors_1.colors.WHITE) : colors_1.colors.WHITE;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color ? colorHelpers_1.default(color, theme, colors_1.colors.GREY_650) : colors_1.colors.GREY_650;
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return colorHelpers_1.default(borderColor, theme, colors_1.colors.GREY_400);
}, function (_a) {
    var borderless = _a.borderless;
    return borderless ? 'none' : 'solid ';
}, function (_a) {
    var borderless = _a.borderless, inputPadding = _a.inputPadding, search = _a.search;
    return borderless
        ? '14px 0'
        : search ? '14px 32px 14px 46px'
            : inputPadding ? inputPadding
                : '14px 32px 14px 16px';
}, function (_a) {
    var inputHeight = _a.inputHeight;
    return inputHeight ? inputHeight : '48px';
}, function (_a) {
    var width = _a.width;
    return width ? width : '100%';
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return colorHelpers_1.default(borderColor, theme, colors_1.colors.GREY_400);
});
var templateObject_1;
//# sourceMappingURL=Select.js.map